import React, { Component} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import * as constants from './config/constants';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/AssignmentInd';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import MoneyIcon from '@material-ui/icons/AttachMoney';
import CategoryIcon from '@material-ui/icons/SpeakerGroup';
import PrintIcon from '@material-ui/icons/Print';
import { Link } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

const drawerWidth = 240;

const styles = theme => ({
	drawerPaper: {
		position: 'relative',
		width: drawerWidth,
	},
	root: {
		flexGrow: 1,
	},
	flex: {
		flex: 1,
	},
	menuButton: {
		marginLeft: -12,
		marginRight: 20,
	},
});

const linkStyle = {
	textDecoration: 'none',
	color: 'unset',
	border: 'none',
	'outline': 'none'
};

class Header extends Component {
	constructor(){
		super();
		this.state = {
			drawer: false,
			anchorEl: null,
			menuOpen: false
		}
		this.handleMenu = this.handleMenu.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleLogout = this.handleLogout.bind(this);
	}
	handleLogout = () => {
		let copiedStates = Object.assign({}, this.state);
		localStorage.removeItem("user");
		copiedStates.menuOpen = false;
		this.setState(copiedStates);
		window.location.href = constants.PRODUCT_BASE_URL + "login"; 
	}
	toggleDrawer = () => {
		this.setState({
			drawer: !this.state.drawer
		});
	}
	handleMenu = event => {
		let copiedStates = Object.assign({}, this.state);
		copiedStates.anchorEl = event.currentTarget;
		copiedStates.menuOpen = true;
		this.setState(copiedStates);
	};

	handleClose = () => {
		let copiedStates = Object.assign({}, this.state);
		copiedStates.anchorEl = null;
		copiedStates.menuOpen = false;
		this.setState(copiedStates);
	};
	render = () => {
		const { classes } = this.props;

		const sideList = [
		<ListItem >
		<ListItemIcon>
		<Avatar src="logo-150.png" />
		</ListItemIcon>
		<ListItemText primary="ETHNUS" />
		</ListItem>,
		<Divider />,
		<Link to="/associates" style={linkStyle} >
		<ListItem button
		onClick={this.toggleDrawer} >
		<ListItemIcon>
		<SupervisorAccountIcon />
		</ListItemIcon>
		<ListItemText primary="Associates" />
		</ListItem>
		</Link>,
		<Divider inset />,
		<Link to="/asset" style={linkStyle} >
		<ListItem button
		onClick={this.toggleDrawer} >
		<ListItemIcon>
		<PrintIcon />
		</ListItemIcon>
		<ListItemText primary="Assets" />
		</ListItem>
		</Link>,
		<Divider inset />,
		<Link to="/allocation" style={linkStyle} >
		<ListItem button
		onClick={this.toggleDrawer} >
		<ListItemIcon>
		<InboxIcon />
		</ListItemIcon>
		<ListItemText primary="Allocations" />
		</ListItem>
		</Link>,
		<Divider inset />,
		<Link to="/vendor" style={linkStyle} >
		<ListItem button
		onClick={this.toggleDrawer} >
		<ListItemIcon>
		<MoneyIcon />
		</ListItemIcon>
		<ListItemText primary="Vendors" />
		</ListItem>
		</Link>,
		<Divider inset />,
		<Link to="/category" style={linkStyle} >
		<ListItem button
		onClick={this.toggleDrawer} >
		<ListItemIcon>
		<CategoryIcon />
		</ListItemIcon>
		<ListItemText primary="Categories" />
		</ListItem>
		</Link>,
		];

		return(
			<div>

			<Drawer
			classes={{
				paper: classes.drawerPaper,
			}}
			open={this.state.drawer}
			onClose={this.toggleDrawer}
			>
			<List component="nav">
			{sideList}
			</List>
			</Drawer>

			<AppBar position="static">
			<Toolbar>
			{constants.isLoggedIn() && (
				<IconButton
				onClick={this.toggleDrawer}
				onKeyDown={this.toggleDrawer}
				className={classes.menuButton}
				color="inherit"
				aria-label="Menu">
				<MenuIcon />
				</IconButton>
				)}
			<Typography variant="title" color="inherit" className={classes.flex}>
			Asset Management
			</Typography>
			{constants.isLoggedIn() && (
				<div>
				<IconButton
				aria-owns={this.state.menuOpen ? 'menu-appbar' : null}
				aria-haspopup="true"
				onClick={this.handleMenu}
				color="inherit"
				>
				<AccountCircle />
				</IconButton>
				<Menu
				anchorEl={this.state.anchorEl}
				id="menu-appbar"
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				open={this.state.menuOpen}
				onClose={this.handleClose}
				>
				<MenuItem onClick={this.handleLogout}>Logout</MenuItem>
				</Menu>
				</div>
				)}

			</Toolbar>
			</AppBar>
			</div>
			);
	}
}

Header.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);


// WEBPACK FOOTER //
// ./src/header.js